export function FloatingShapes() {
  return (
    <div className="fixed inset-0 pointer-events-none" aria-hidden="true">
      <div
        className="absolute -top-32 -right-24 w-[450px] h-[450px] rotate-[10deg] opacity-[0.06]"
        style={{ backgroundColor: 'var(--decoration-primary)', clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)' }}
      />
      <div
        className="absolute top-[18%] -left-40 w-[500px] h-[500px] rotate-[-15deg] opacity-[0.08]"
        style={{ backgroundColor: 'var(--decoration-secondary)', clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)' }}
      />
      <div
        className="absolute top-[55%] right-[8%] w-[380px] h-[380px] rotate-[25deg] opacity-[0.05]"
        style={{ backgroundColor: 'var(--decoration-primary)', clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)' }}
      />
      <div
        className="absolute top-[10%] left-[25%] w-[200px] h-[200px] rotate-[35deg] opacity-[0.05]"
        style={{ backgroundColor: 'var(--decoration-secondary)', clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)' }}
      />
      <div
        className="absolute top-[75%] left-[5%] w-[300px] h-[300px] rotate-[-5deg] opacity-[0.06]"
        style={{ backgroundColor: 'var(--decoration-secondary)', clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)' }}
      />
      <div
        className="absolute top-[40%] left-[50%] w-[350px] h-[350px] rotate-[20deg] opacity-[0.04]"
        style={{ backgroundColor: 'var(--decoration-primary)', clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)' }}
      />
    </div>
  );
}
